import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { FirebaseError } from 'firebase/app';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';

import { SnackBarService } from '../../../../core/services/snack-bar.service';
import { FirebaseService } from '../../../services/firebase.service';

@Component({
	selector: 'dix-reset-password-dialog',
	templateUrl: './reset-password-dialog.component.html',
	styleUrls: ['./reset-password-dialog.component.scss'],
	standalone: false,
})
export class ResetPasswordDialogComponent {
	private readonly auth = inject(FirebaseService).auth;

	form = new FormGroup({
		oldPassword: new FormControl('', [Validators.required]),
		password: new FormControl('', [Validators.required]),
		confirmPassword: new FormControl('', [Validators.required]),
	});

	passwordMismatch = false;
	wrongPassword = false;
	loading = false;

	constructor(
		private snackbarService: SnackBarService,
		public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
	) {}

	async resetPassword() {
		if (this.form.invalid || this.loading) {
			return;
		}
		this.wrongPassword = false;
		this.passwordMismatch = this.form.controls.password.value !== this.form.controls.confirmPassword.value;
		if (this.passwordMismatch) {
			return;
		}
		this.loading = true;
		try {
			const { currentUser } = this.auth;
			const credential = EmailAuthProvider.credential(currentUser.email, this.form.controls.oldPassword.value);
			await reauthenticateWithCredential(currentUser, credential);
			await updatePassword(currentUser, this.form.controls.password.value);
			this.snackbarService.open('Password reset complete.');
			this.dialogRef.close();
		} catch (e) {
			if ((e as FirebaseError).code === 'auth/wrong-password') {
				this.wrongPassword = true;
				return;
			}
			this.snackbarService.open('An error occurred while resetting the password. Please try again or contact support.');
		} finally {
			this.loading = false;
		}
	}
}
